// extracted by mini-css-extract-plugin
export default {"container":"OrderConfirmation_container__83kbt","search_select":"OrderConfirmation_search_select__n+SCw","actions":"OrderConfirmation_actions__il16B"};